<template>
    <div>
        <div
            class="content-message"
            v-show=" index > 2 ? isShow:true"
            :class="comment_list.length - 1 === index ? '':'content-message-border'"
        >
            <div class="content-message-details">
                <van-image
                  round
                  class="avater"
                  v-if="!item.is_actual"
                  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72"
                />
                <van-image
                  fit="cover"
                  round
                  class="avater"
                  @click="goDDconversation"
                  v-else
                  :src="`${item.user.real_avatar !== 'null' && item.user.real_avatar !== '' ? item.user.real_avatar : item.user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"
                >
                  <template v-slot:error>{{ getErrorName }}</template>
                </van-image>
                <div class="content-message-item-body">
                    <div class="content-message-item-body-header">
                        <span
                            @click="goDDconversation"
                            class="content-message-item-body-header-h2"
                        >{{ !item.is_actual ? '匿名用户' : item.user.fullname ? item.user.fullname : item.user.nickName }}</span>
                    </div>
                    <div class="content-message-item-desc">
                      <!-- v-html="item.content.replace(/\n/g,'</br>')" -->
                        <span
                            class="descInfo_message"
                            :style="{ display: (expand ? 'block' : '-webkit-box') }"
                            :ref="`${item.circle_id}message`"
                            v-html="item.parent_comment_nickname ? `回复<span class='message_nickname'>@${item.parent_comment_nickname}：</span>${item.content.replace(/\n/g,'</br>')}`:item.content.replace(/\n/g,'</br>')"
                        ></span>
                        <span
                            v-if="showPand"
                            @click.stop="expand = !expand"
                            class="expand retract"
                        >{{ expand ? '收起' : '展开' }}</span>
                    </div>
                    <div class="content-message-item-bottom">
                        <div class="content-message-item-bottom-left">
                            <h5>{{ getShowTime(item.createTime) }}</h5>
                        </div>
                        <div class="menus">
                            <ThumbUpItem @click="commentThumbsUp(item)" width="45px" v-bind="item" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="restsMessage" v-if="comment_list.length > 3 && index === comment_list.length - 1" @click="isShowRestsMessage">
            <span class="resteMessage_text">{{ !isShow ? comment_list.length + '条评论' : '收起评论' }}</span>
            <van-icon name="arrow-down" v-if="!isShow" />
            <van-icon name="arrow-up" v-else />
        </div>
    </div>
</template>

<script>
import { post } from '../utils/request'
import { get } from '../utils/token'
import ThumbUpItem from './thunmbUpItem'
import { getBeforeTimeStr } from '../utils/date'
import { isOverflow, openSingleChat } from '../utils/utils'
import { messageInform } from '../api/api'
export default {
  components: {
    ThumbUpItem
  },
  props: {
    item: {
    //   type: Object
    },
    comment_list: {},
    index: {},
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPand: false,
      expand: false,
      // isShow: false,
      showPandMessage: false, // 是否显示留言展开
      expandMessage: false // 展开
    }
  },
  computed: {
    getErrorName () {
      const name = this.item.user.fullname ? this.item.user.fullname : this.item.user.nickName
      for (let i = 0; i < name.length; i++) {
        const charCode = name.charCodeAt(i)
        if (charCode >= 0x4e00 && charCode <= 0x9fff) {
          return name.charAt(i)
        }
      }
      return name[0]
    }
  },
  mounted () {
    this.judgePand()
    // const _this = this
    // dd.device.base.getPhoneInfo({
    //   onSuccess: function (data) {
    //     // alert('现在是手机移动端')
    //     _this.isPc = false
    //   },
    //   onFail: function (err) {
    //     alert(JSON.stringify(err))
    //   }
    // })
  },
  methods: {
    // 跳转钉钉聊天框逻辑
    goDDconversation () {
      // 先判断是否为移动钉钉端
      if (!this.item.is_actual) {
        return
      }
      openSingleChat({
        name: this.item.user.fullname ? this.item.user.fullname : this.item.user.nickName,
        userId: this.item.user.jobCode
      })
    },
    // 点赞触发
    commentThumbsUp (item) {
      // console.log(item)
      const promsie = post({
        url: `/circle/isUpComment/${item.nid}/${get('user').id}`,
        data: {
          isUp: !item.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        // console.log(status)
        if (Object.is(status, 200)) {
          item.isUp = !item.isUp
          if (item.isUp && this.$route.path.indexOf('overseasDetail') === -1) {
            messageInform({
              circle_id: this.item.circle_id,
              action_type: 3,
              mobile: this.item.user.username,
              operator_mobile: get('user').username,
              is_anonymous: !this.item.is_actual,
              comment_id: this.item.nid
            })
          }
          let count = item.upCount
          if (item.isUp) {
            ++count
          } else {
            --count
          }
          item.upCount = count
        }
      })
    },
    judgePand () {
      const ref = `${this.item.circle_id}message`
      this.$nextTick(() => {
        const el = this.$refs[`${ref}`]
        this.showPand = isOverflow(el)
        // console.log(el.clientHeight, el.offsetHeight, el.offsetHeight, el.getBoundingClientRect())
      })
    },
    // 是否显示更多留言
    isShowRestsMessage () {
      // console.log(el)
      // this.isShow = !this.isShow
      this.$emit('isShowMessage')
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    }
  }
}
</script>

<style lang="scss" scoped>
    .AtSpan {
      margin: 0 5px;
      color: #5b78a3;
    }
    .avater {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin-right: 16px;
    }
    .expand {
        color: #18cc9f;
        white-space: nowrap;
        // display: flex;
        // justify-items: flex-end;
        // position: absolute;
        // bottom: 2px;
        // right: 0;
        padding-left: 2px;
        background: #fff;
        // background:-webkit-linear-gradient(left,transparent,#fff 55%);
        // background:-o-linear-gradient(right,transparent,#fff 55%);
        // background:-moz-linear-gradient(right,transparent,#fff 55%);
        // background:linear-gradient(to right,transparent,#fff 55%);
      }
      .retract {
        bottom: -20px;
        left: 0;
      }
    .content-message-border{
        border-bottom: 1px solid #f5f5f5;
    }
    .content-message{
      margin-top: 3px;
      .content-message-details{
        display:flex;
        .content-message-item-body{
          // width:100%;
        }
        .content-message-item-body-header-h2{
          color: #75a1c7;
          font-size: 14px;
        }
        .content-message-item-desc{
          font-size:14px;
          width: 100%;
          box-sizing: border-box;
          position: relative;
          .descInfo_message{
            white-space: pre-wrap;
            box-sizing: border-box;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 24px;
            // height: auto;
            width: 60vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            // border: 1px solid red;
            .message_nickname {
              color: #888888;
            }
          }
        }
        .content-message-item-bottom{
          display: flex;
          height: 30px;
          justify-content: space-between;
          align-items: center;
          .content-message-item-bottom-left{
              font-size: 14px;
              font-family: SFProText-Regular, SFProText;
              font-weight: 400;
              color: rgba(60, 60, 67, 0.6);
              line-height: 13px;
          }
        }
      }
    }
   .restsMessage{
    height:10px;
    line-height: 10px;
    .resteMessage_text{
      color: #20CEA2;
      font-size: 14px;
    }
   }
</style>
